import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useBranch } from '../../context/BranchContext';
import { FiUser, FiLogOut, FiHome, FiPlusCircle } from 'react-icons/fi';
import './GlobalNavbar.css';

const GlobalNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const { selectedBranch, clearBranch } = useBranch();

  const handleLogout = () => {
    clearBranch();
    logout();
    navigate('/login');
  };

  const handleSwitchBranch = () => {
    clearBranch();
    navigate('/select-branch');
  };

  const handleNewLocation = () => {
    // Navigate to new location creation page
    navigate('/settings?tab=locations');
  };

  // Don't show navbar only on login/auth pages (show on landing page)
  const hideNavbar = ['/login', '/join-now'].includes(location.pathname);
  
  // For landing page, show simplified navbar without user menu
  const isLandingPage = ['/home', '/pricing', '/'].includes(location.pathname);

  if (hideNavbar) {
    return null;
  }

  return (
    <nav className="global-navbar">
      <div className="navbar-container">
        {/* Left Side - Logo and Branding */}
        <div className="navbar-left">
          <div className="navbar-logo" onClick={() => isLandingPage ? navigate('/') : navigate('/dashboard')}>
            <span className="logo-text">Paddel POS</span>
          </div>
        </div>

        {/* Right Side - Navigation Links and User Menu */}
        <div className="navbar-right">
          {isLandingPage ? (
            // Landing page navigation
            <div className="navbar-links">
              <button
                className="nav-link"
                onClick={() => navigate('/login')}
              >
                <span>Login</span>
              </button>
              <button
                className="nav-link"
                onClick={() => navigate('/join-now')}
                style={{ background: 'rgba(255, 255, 255, 0.2)', border: '1px solid rgba(255, 255, 255, 0.3)' }}
              >
                <span>Get Started</span>
              </button>
            </div>
          ) : (
            // Authenticated navigation
            <>
              <div className="navbar-links">
                <button
                  className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
                  onClick={() => navigate('/dashboard')}
                >
                  <FiHome className="nav-icon" />
                  <span>Dashboard</span>
                </button>

                <button
                  className="nav-link"
                  onClick={handleNewLocation}
                >
                  <FiPlusCircle className="nav-icon" />
                  <span>New Location</span>
                </button>

                {selectedBranch && (
                  <button
                    className="nav-link switch-branch-btn"
                    onClick={handleSwitchBranch}
                  >
                    <span>Switch Branch</span>
                  </button>
                )}
              </div>

              {user && (
                <div className="navbar-user-menu">
                  <div className="user-profile">
                    <div className="user-avatar">
                      {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                    </div>
                    <div className="user-info">
                      <span className="user-name">{user?.name || 'User'}</span>
                      {selectedBranch && (
                        <span className="user-branch">{selectedBranch.name}</span>
                      )}
                    </div>
                  </div>

                  <button className="logout-btn" onClick={handleLogout} title="Logout">
                    <FiLogOut className="logout-icon" />
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default GlobalNavbar;

